import React from 'react';
import { Row, Col, Card, Typography, Space } from 'antd';
import ByLeadersBarChart from '../../graphics/byLeadersBarChart';

const { Text, Title } = Typography;

const LeadershipNPS = ({
    recommended = [],
    notRecommended = [],
    chartData = [],
    redLight,
    yellowLight,
    showCards = false
}) => {
    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            {/* ✅ Recomendaciones solo si showCards es true */}
            {showCards && (
                <Row gutter={[16, 16]} align="stretch">
                    <Col xs={24} md={24}>
                        {(recommended.length === 0 && notRecommended.length === 0) ? (
                            <Card bordered>
                                <Text style={{ fontSize: '16px', textAlign: 'justify' }}>
                                    Los resultados no arrojaron información suficiente para recomendar o no recomendar líderes.
                                </Text>
                            </Card>
                        ) : (
                            <Row gutter={16}>
                                {/* Recomendados */}
                                <Col xs={24} md={12}>
                                    <Title level={5} style={{ color: "#43a047" }}>
                                        ✅ Personas recomendadas para ejercer liderazgo
                                    </Title>
                                    <Card styles={{ body: { padding: 12 } }} style={{ backgroundColor: "#e8f5e9" }}>
                                        <ul style={{ paddingLeft: 20, marginBottom: 0, marginTop: 0 }}>
                                            {recommended.map((p, i) => (
                                                <li key={`rec-${i}`}>
                                                    <Text>{p.first_name} {p.last_name}</Text>
                                                </li>
                                            ))}
                                        </ul>
                                    </Card>
                                </Col>

                                {/* No recomendados */}
                                <Col xs={24} md={12}>
                                    <Title level={5} style={{ color: "#e53935" }}>
                                        ❌ Personas no recomendadas para liderar a otros
                                    </Title>
                                    <Card styles={{ body: { padding: 12 } }} style={{ backgroundColor: "#ffebee" }}>
                                        <ul style={{ paddingLeft: 20, marginBottom: 0, marginTop: 0 }}>
                                            {notRecommended.map((p, i) => (
                                                <li key={`not-rec-${i}`}>
                                                    <Text>{p.first_name} {p.last_name}</Text>
                                                </li>
                                            ))}
                                        </ul>
                                    </Card>
                                </Col>
                            </Row>
                        )}
                    </Col>
                </Row>
            )}

            {/* Gráfico */}
            <Row gutter={[16, 16]}>
                <Col xs={24}>
                    <div style={{ marginTop: 16 }}>
                        <ByLeadersBarChart
                            data={chartData}
                            redLight={redLight}
                            yellowLight={yellowLight}
                        />
                    </div>
                </Col>
            </Row>
        </Space>
    );
};

export default LeadershipNPS;
